import Breadcrumbs from 'components/Breadcrumbs';
import { Button } from 'components/buttons/Button/Button';
import './styles.scss';

const Banner = ({
    title = '',
    image,
    buttonText,
    buttonType = 'learn-more',
    children = undefined,
    withCrumbs = true,
}) => {
    return (
        <>
            <div className="primary-section-wrapper">
                <div className="primary-section">
                    <div className="left-side">
                        {withCrumbs && <Breadcrumbs />}
                        {title ? <h2>{title}</h2> : <div className="left-side__content">{children}</div>}
                    </div>
                    <div className="button-wrapper">
                        <Button type={buttonType}>{buttonText}</Button>
                        <div className="smooth-corner1"></div>
                        <div className="smooth-corner2"></div>
                    </div>
                </div>
                <img className="bg" src={image} alt={title} />
            </div>
            {buttonType.includes('find') && (
                <Button type="find-mobile" className="banner-bottom">
                    {buttonText}
                </Button>
            )}
            {buttonType.includes('banner') && <Button className="banner-bottom">{buttonText}</Button>}
        </>
    );
};
export default Banner;
